import gql from 'graphql-tag';

export const checkoutPrice = gql`
  query checkoutPrice(
    $account_id: RecordID
    $address_id: RecordID
    $subscription_items: [CheckoutSubscriptionItem]
    $custom_print_items: [CheckoutCustomPrintItem]
    $photo_items: [CheckoutPhotoItem]
    $photo_print_items: [CheckoutPhotoPrintItem]
    $photo_download_items: [CheckoutPhotoDownloadItem]
    $search_subscription_items: [CheckoutSearchSubscriptionItem]
    $promo_code: String
    $event_items: [CheckoutEventItem]
    $event_addon_items: [CheckoutEventAddonItem]
    $digital_bundle_items: [CheckoutDigitalBundleItem!]
    $print_order_service_items: [CheckoutPrintOrderServiceItem!]
  ) {
    checkoutPrice(
      account_id: $account_id
      account_address_id: $address_id
      subscription_items: $subscription_items
      custom_print_items: $custom_print_items
      photo_items: $photo_items
      photo_print_items: $photo_print_items
      photo_download_items: $photo_download_items
      search_subscription_items: $search_subscription_items
      promo_code: $promo_code
      event_items: $event_items
      event_addon_items: $event_addon_items
      digital_bundle_items: $digital_bundle_items
      print_order_service_items: $print_order_service_items
    ) {
      total_price {
        value
        currency
      }
      total_shipping_cost {
        value
        currency
      }
      total_tax {
        value
        currency
      }
      custom_prints_total_price {
        value
        currency
      }
      custom_prints_shipping_cost {
        value
        currency
      }
      total_discount_price {
        value
        currency
      }
      requires_payment
      stripe_connect_account_id
    }
  }
`;
